import React from "react";

/**
 * Renders the Laguna brand mark: word + coral period.
 *
 * Usage rule (strict):
 *  - ONLY for standalone subject/object references to the company.
 *    e.g. "<BrandMark /> is the broker, not your employer."
 *  - NEVER in compounds: "Laguna Benefits", "Laguna team", "Laguna thesis".
 *  - NEVER in the MassMutual legal disclaimer.
 *  - NEVER inside the site's own logo (which has its own renderer).
 *
 * Rendered inline — the dot inherits the coral accent color.
 */
export default function BrandMark({ as: Tag = "span", className = "" }) {
    return (
        <Tag className={`brand-mark ${className}`} data-testid="brand-mark">
            Laguna<span className="brand-dot" style={{ color: "var(--accent)" }}>.</span>
        </Tag>
    );
}
